<template>
  <header v-if="showHeader" class="bg-white header min-h-[222px]">
    <nav class="max-w-[1650px] mx-auto pt-[75px] pb-[69px] px-[20px]">
      <div class="w-full pb-1 mx-auto">
        <div class="nav__container flex items-center justify-between">
          <!-- Website Logo -->
          <router-link to="/" class="flex items-center router-link-active">
            <img src="/images/geeq-logo.png" alt="Logo">
          </router-link>
          <div>
             <!-- Button to open Login modal -->
            <GeeqButton v-show="!isLoggedIn" @onClick="triggerLoginModal"
                classes="capitalize !bg-blue-vip text-white !min-h-[40px] !max-h-[50px] !w-[135px]" label="Login"
                type="button" />
            <!-- / Button to open Login modal -->
                <!-- Button to open Login modal -->
            <GeeqButton v-show="isLoggedIn" @onClick="triggerPasswordResetModal"
                classes="capitalize !bg-blue-vip text-white !min-h-[40px] !max-h-[50px] !w-[170px]" label="Reset password"
                type="button" />
            <!-- / Button to open Login modal -->
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import GeeqButton from '@/components/common/GeeqButtonComponent.vue';

export default {
  name: 'AdminHeaderComponent',
  components: {
    GeeqButton,
  },
  props: {
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({isLoggedIn: 'getIsLoggedIn'}),
  },
  data: () => ({
    //
  }),
  methods: {
     triggerLoginModal() {
      const event = new CustomEvent('login', {
        detail: { message: 'logging in' }
      });
      document.dispatchEvent(event);
    },
    triggerPasswordResetModal() {
      const event = new CustomEvent('passwordReset');
      document.dispatchEvent(event);
    },
  },
}
</script>

<style>
.header .search-form .search-input {
  background: #F6F6F6 !important;
}
</style>
